import { render } from "./CreateAnnotationSetModal.vue?vue&type=template&id=c49010e2&scoped=true"
import script from "./CreateAnnotationSetModal.vue?vue&type=script&lang=js"
export * from "./CreateAnnotationSetModal.vue?vue&type=script&lang=js"

import "./CreateAnnotationSetModal.vue?vue&type=style&index=0&id=c49010e2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c49010e2"]])

export default __exports__